module.exports = __webpack_public_path__ + "img/ysgj_011@2x.f7c500d4.png";